import {
  Button,
  Cascader,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  TreeSelect,
  Row,
  Col,
  Pagination,
  message,
} from "antd";
import moment from "moment/moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { getHouseList } from "../../api/api";
import HouseTable from "./components/houseTable/houseTable";
import "./houseManage.css";

const { RangePicker } = DatePicker;
const HouseManage = () => {
  const [form] = Form.useForm();
  const [componentSize, setComponentSize] = useState("default");
  const unitref = useRef();
  const [payload, setPayload] = useState({ page: "1", pagesize: "10" });
  const [total, setTotal] = useState(0);
  const [isFresh, setIsfresh] = useState(false);
  useEffect(() => {
    console.log("father refresh!");
    getHouseList({ params: payload }).then((res) => {
      const info = res?.data?.data;
      if (info.total === 0) {
        message.error("未能找到指定条件内容！");
      }
      unitref.current.changeTable(info.rows);
      setTotal(info.total);
    });
  }, [payload, isFresh]);

  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size);
  };

  const handleSubmit = (values) => {
    // console.log(values);
    // console.log(qs.stringify(values.is_recommend,{arrayFormat:'comma'}));
    let payload = {
      title: values.title,
      page: "1",
      pagesize: "10",
      is_recommend: values.is_recommend,
      is_recommend_ad: values.is_recommend_ad,
      is_prioritized: values.is_prioritized,
      is_show: values.is_show,
      regions: values.regions,
      rooms_actual: values.rooms_actual,
      types: values.types,
    };
    let start = values?.date[0];
    let end = values?.date[1];
    console.log();
    if (start !== "") {
      payload["period_start"] = moment(start).format("YYYY-MM-DD");
    }
    if (end !== "") {
      payload["period_end"] = moment(end).format("YYYY-MM-DD");
    }
    // console.log(qs.stringify(payload));
    setPayload(payload);
  };

  const resetSelectors = () => {
    form.resetFields();
  };

  const pageChange = (e) => {
    setPayload({
      ...payload,
      page: e,
    });
  };
  return (
    <div
      className="houseManage"
      style={{ backgroundColor: "white", padding: "30px" }}
    >
      <div className="houseSelector">
        <Form
          initialValues={{
            size: componentSize,
            date: ["", ""],
          }}
          onValuesChange={onFormLayoutChange}
          onFinish={handleSubmit}
          size={componentSize}
          className="houseSelectors"
          form={form}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="房源信息" name="title" className="houseContent">
                <Input placeholder="请输入房源编号/房源标题" />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="区域" name="regions" className="area">
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  style={{ textAlign: "left" }}
                  getPopupContainer={(e) => e}
                >
                  <Select.Option value="1">Cannon Park Region</Select.Option>
                  <Select.Option value="2">Charter Avenue</Select.Option>
                  <Select.Option value="3">Sir Henry Parkes Road</Select.Option>
                  <Select.Option value="4">White Willow Park</Select.Option>
                  <Select.Option value="5">Torrington Avenue</Select.Option>
                  <Select.Option value="6">其他</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="发布时间" name="date" className="postTime">
                <RangePicker />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="首页推荐"
                name="is_recommend"
                className="recommandStatus"
              >
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  style={{ textAlign: "left" }}
                  getPopupContainer={(e) => e}
                >
                  <Select.Option value={1}>已推荐</Select.Option>
                  <Select.Option value={0}>未推荐</Select.Option>
                </Select>
              </Form.Item>
            </Col>

{/* 废弃 */}
            {/* <Col span={8}>
              <Form.Item
                label="房间数"
                name="rooms_actual"
                className="houseCount"
              >
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  style={{ textAlign: "left" }}
                  getPopupContainer={(e) => e}
                >
                  <Select.Option value={1}>1</Select.Option>
                  <Select.Option value={2}>2</Select.Option>
                  <Select.Option value={3}>3</Select.Option>
                  <Select.Option value={4}>4</Select.Option>
                  <Select.Option value={5}>5</Select.Option>
                  <Select.Option value={6}>6</Select.Option>
                  <Select.Option value={7}>7</Select.Option>
                  <Select.Option value={8}>8</Select.Option>
                  <Select.Option value={9}>9</Select.Option>
                </Select>
              </Form.Item>
            </Col> */}

            <Col span={8}>
              <Form.Item label="上架状态" name="is_show" className="upStatus">
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  style={{ textAlign: "left" }}
                  getPopupContainer={(e) => e}
                >
                  <Select.Option value={1}>已上架</Select.Option>
                  <Select.Option value={0}>未上架</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="房源类型" name="types" className="types">
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  style={{ textAlign: "left" }}
                  getPopupContainer={(e) => e}
                >
                  <Select.Option value={1}>超豪华别墅</Select.Option>
                  <Select.Option value={2}>距学校超级近</Select.Option>
                  <Select.Option value={3}>超高性价比</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="广告推荐"
                name="is_recommend_ad"
                className="is_recommend_ad"
              >
                <Select
                  placeholder="请选择"
                  style={{ textAlign: "left" }}
                  getPopupContainer={(e) => e}
                >
                  <Select.Option value={1}>参与</Select.Option>
                  <Select.Option value={0}>不参与</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="推荐排序"
                name="is_prioritized"
                className="is_prioritized"
              >
                <Select
                  placeholder="请选择"
                  style={{ textAlign: "left" }}
                  getPopupContainer={(e) => e}
                >
                  <Select.Option value={1}>优先</Select.Option>
                  <Select.Option value={0}>未优先</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={20}></Col>
            <Col span={4}>
              <Form.Item>
                <Button
                  onClick={resetSelectors}
                  style={{ marginRight: "20px" }}
                >
                  重置
                </Button>

                <Button type="primary" htmlType="submit">
                  查询
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <HouseTable ref={unitref} setIsFresh={setIsfresh} />
      <Pagination
        showQuickJumper
        style={{ textAlign: "right" }}
        onChange={pageChange}
        total={total}
        key={total}
        pageSize={10}
        // current={1}
        defaultCurrent={1}
        showTotal={(total, range) =>
          `共${total}条记录, 第${range[0]}-${range[1]}条`
        }
      />
    </div>
  );
};
export default HouseManage;
